// Theme events for janado analytics. They go to Shopify's customer events (Shopify.analytics.publish) and reach our
// custom pixel only when the visitor allowed analytics. No personal data: counts, amounts, page type, timings.
// Watches the existing markup instead of hooking into other scripts, so cart-drawer.js stays untouched:
//   Paket 1 (Warenkorb): janado:cart_drawer_opened / _closed, janado:cart_offer_shown / _applied / _expired
//   Paket 2 (Technik):   janado:js_error, janado:web_vitals (LCP, INP, CLS once per page)

// own scope: classic scripts share the global scope (a second top-level `const dlg` breaks Safari)
;(() => {
const publish = (name, data = {}) => {
  try {
    window.Shopify?.analytics?.publish?.(`janado:${name}`, data)
  } catch (e) {}
}
const pageType = () => {
  const p = location.pathname
  return /\/products\//.test(p) ? 'product' : /\/collections\//.test(p) ? 'collection' : /\/cart/.test(p) ? 'cart'
    : /\/search/.test(p) ? 'search' : /\/blogs\//.test(p) ? 'blog' : /^\/([a-z]{2}(-[a-z]{2})?\/?)?$/.test(p) ? 'home' : 'other'
}

// ------------------------------------------------------------------ Paket 1: cart drawer + leave offer
const dlg = document.getElementById('CartDrawer')
if (dlg) {
  const cartInfo = () => fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json())
    .then((c) => ({ items: c.item_count, value: c.total_price / 100 })).catch(() => ({}))

  // drawer open / close
  let openedAt = 0
  new MutationObserver(() => {
    if (dlg.open && !openedAt) { openedAt = Date.now(); publish('cart_drawer_opened', { page_type: pageType() }) }
  }).observe(dlg, { attributes: true, attributeFilter: ['open'] })
  dlg.addEventListener('close', () => {
    if (!openedAt) return
    publish('cart_drawer_closed', { seconds_open: Math.round((Date.now() - openedAt) / 1000) })
    openedAt = 0
  })

  // what made the offer appear: the last attempt to leave within 1.5 s (closing the drawer, mouse to the top, tab switch)
  let trigger = null
  const mark = (t) => { trigger = { t, at: Date.now() } }
  dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-cart-close]')) mark('close') }, true)
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && dlg.open) mark('close') }, true)
  document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) mark('exit_intent') }, true)
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') mark('tab_return') })

  // offer shown / expired: watch the [data-offer] element (the drawer re-renders, so observe the whole dialog)
  let shownAt = 0
  const offerState = () => {
    const o = dlg.querySelector('[data-offer]')
    const visible = !!o && !o.hidden
    if (visible && !shownAt) {
      shownAt = Date.now()
      const how = trigger && Date.now() - trigger.at < 1500 ? trigger.t : 'already_shown' // e.g. reopened drawer with a running countdown
      cartInfo().then((c) => publish('cart_offer_shown', { trigger: how, ...c }))
    } else if (!visible && shownAt && o) {
      // hidden again while the drawer still holds it: the countdown ran out
      if (o.hidden && /0:00/.test(o.querySelector('[data-offer-time]')?.textContent || '')) publish('cart_offer_expired', {})
      shownAt = 0
    }
  }
  new MutationObserver(offerState).observe(dlg, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] })

  // offer applied (the click applies the code and goes on to the checkout)
  dlg.addEventListener('click', (e) => {
    if (!e.target.closest('[data-offer-apply]')) return
    const t = dlg.querySelector('[data-offer-time]')?.textContent || ''
    const [m, s] = t.split(':').map(Number)
    publish('cart_offer_applied', { seconds_left: Number.isFinite(m) ? m * 60 + (s || 0) : null })
  }, true)
}

// ------------------------------------------------------------------ Paket 2: JS errors + Core Web Vitals
let errors = 0
const fileOf = (src) => { try { return new URL(src, location.href).pathname.split('/').pop().slice(0, 80) } catch (e) { return '' } }
addEventListener('error', (e) => {
  if (!(e instanceof ErrorEvent) || errors++ >= 5) return // max 5 per page
  publish('js_error', { message: String(e.message || 'Script error').slice(0, 150), file: fileOf(e.filename), line: e.lineno || null, page_type: pageType() })
})
addEventListener('unhandledrejection', (e) => {
  if (errors++ >= 5) return
  publish('js_error', { message: String(e.reason?.message || e.reason || 'Unhandled rejection').slice(0, 150), file: '', line: null, kind: 'promise', page_type: pageType() })
})

const vitals = { lcp: null, inp: null, cls: 0 }
const watch = (type, fn, extra = {}) => { try { new PerformanceObserver((l) => l.getEntries().forEach(fn)).observe({ type, buffered: true, ...extra }) } catch (e) {} }
watch('largest-contentful-paint', (en) => { vitals.lcp = Math.round(en.startTime) })
// CLS: largest burst of shifts (gaps < 1 s, burst < 5 s), shifts right after input don't count
let burst = 0, burstStart = 0, last = 0
watch('layout-shift', (en) => {
  if (en.hadRecentInput) return
  if (en.startTime - last > 1000 || en.startTime - burstStart > 5000) { burst = 0; burstStart = en.startTime }
  burst += en.value; last = en.startTime
  vitals.cls = Math.max(vitals.cls, burst)
})
// INP (approximation for one page): the slowest interaction
watch('event', (en) => { if (en.interactionId) vitals.inp = Math.max(vitals.inp || 0, Math.round(en.duration)) }, { durationThreshold: 40 })

// Sent 8 s after load (or earlier when the page is hidden): Shopify forwards events to the pixel asynchronously, and
// at the very end of a page that hand-over gets lost. LCP is settled by then; INP covers the interactions until then.
let sent = false
const sendVitals = () => {
  if (sent) return
  sent = true
  publish('web_vitals', { lcp_ms: vitals.lcp, inp_ms: vitals.inp, cls: Math.round(vitals.cls * 1000) / 1000, page_type: pageType(),
    device: matchMedia('(pointer: coarse)').matches ? (Math.min(screen.width, screen.height) >= 600 ? 'tablet' : 'mobile') : 'desktop' })
}
const after = (ms) => setTimeout(sendVitals, ms)
document.readyState === 'complete' ? after(8000) : addEventListener('load', () => after(8000))
addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') sendVitals() })
})()
